import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { downloadContentAuditPdf, openContentAuditReport } from '../utils/contentAuditReport';

// Floating export control for the Content Audit page.
// Downloads a real PDF (rendered server side with Puppeteer) styled like the dashboard,
// including every issue and every affected link.
const WRAP = {
  position: 'fixed',
  bottom: '24px',
  right: '24px',
  zIndex: 9999,
  display: 'inline-flex',
  alignItems: 'center'
};
const BTN = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  padding: '10px 18px',
  borderRadius: '9999px',
  border: 'none',
  color: '#fff',
  fontSize: '14px',
  fontWeight: 600,
  cursor: 'pointer',
  boxShadow: '0 10px 15px -3px rgba(0,0,0,0.25)'
};

export default function ContentAuditExportMenu({ data }) {
  const [busy, setBusy] = useState(false);
  if (!data || !data.categories) return null;

  const handleDownload = async () => {
    if (busy) return;
    setBusy(true);
    const id = toast.loading('Building your PDF report...');
    try {
      const name = await downloadContentAuditPdf(data);
      toast.success('Saved ' + name, { id });
    } catch (err) {
      toast.error('PDF service unavailable - opening the print view instead', { id });
      openContentAuditReport(data);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={WRAP}>
      <button
        type="button"
        disabled={busy}
        title="Download the full audit as a PDF, including every issue and affected link"
        style={{ ...BTN, background: busy ? '#93c5fd' : '#2563eb', cursor: busy ? 'wait' : 'pointer' }}
        onClick={handleDownload}
      >
        <span aria-hidden="true">&#128438;</span>
        {busy ? 'Preparing PDF...' : 'Download PDF'}
      </button>
    </div>
  );
}
